import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'

import ScrollToTop from 'components/ScrollToTop'
import Header from 'components/Header'
import Footer from 'components/Footer'

import Home from 'views/Home'
// import { About, AboutLocation } from 'views/About'
import { AboutLocation } from 'views/About'
import Skills from 'views/Skills'
import Portfolio from 'views/Portfolio'
import PortfolioDetail from 'views/PortfolioDetail'
import Contact from 'views/Contact'
import ContactQuestion from 'components/ContactQuestion'
import ContactInquiry from 'components/ContactInquiry'
import Hugcare from 'views/Hugcare'
import NotFound from 'views/NotFound'
import Recruit from 'views/Recruit'

function App() {
  return (
    <div className='App'>
      <Router>
        <ScrollToTop />
        <Header />
        <Routes>
          <Route path='/' element={<Home />}></Route>
          {/* <Route path='/about' element={<About />}></Route> */}
          <Route path='/about/location' element={<AboutLocation />}></Route>
          <Route path='/skills' element={<Skills />}></Route>
          <Route path='/portfolio' element={<Portfolio />}></Route>
          <Route path='/portfolio/detail/:portfolioKey' element={<PortfolioDetail />}></Route>
          <Route path='/contact/qnas/intro' element={<Contact />}></Route>
          <Route path='/contact/qnas' element={<ContactQuestion />}></Route>
          <Route path='/contact/inquiry' element={<ContactInquiry />}></Route>
          <Route path='/hugcare' element={<Hugcare />}></Route>
          <Route path='/recruit' element={<Recruit />}></Route>
          <Route path='*' element={<NotFound />}></Route>
        </Routes>
        <Footer />
      </Router>
    </div>
  )
}

export default App
